import { Playground } from '@playground';
import { Props } from 'docz';
import { Button } from "../../../../../packages/core/src/components/buttons/buttons";
import * as React from 'react';
export default {
  Playground,
  Props,
  Button,
  React
};